import { useTranslations } from '@vocab/react';
import {
  Box,
  ButtonIcon,
  Column,
  Columns,
  IconSort,
  IconTick,
  Inline,
  MenuItem,
  MenuRenderer,
  Text,
} from 'braid-design-system';
import type { FC } from 'react';

import { APPLIED_JOB_SORT } from 'src/hooks/useSort';

import translations from './JobsContainer.vocab';

interface Props {
  totalJobs: string;
  onSortMenuOpen: () => void;
  handleSortChange: (sort: APPLIED_JOB_SORT) => void;
  currentSort: APPLIED_JOB_SORT;
}

const JobsContainerSortView: FC<Props> = ({
  totalJobs,
  onSortMenuOpen,
  handleSortChange,
  currentSort,
}) => {
  const { t } = useTranslations(translations);
  const renderSortIcon = (sortType: APPLIED_JOB_SORT) =>
    currentSort === sortType ? <IconTick /> : '';

  return (
    <Box paddingBottom="xsmall">
      <Columns space="small" alignY="center">
        <Column>
          <Text>{t('jobs', { count: totalJobs })}</Text>
        </Column>
        <Column>
          <Inline align="right" space="small">
            <MenuRenderer
              reserveIconSpace
              offsetSpace="small"
              trigger={(triggerProps) => (
                <Box userSelect="none" cursor="pointer" {...triggerProps}>
                  <ButtonIcon
                    icon={<IconSort />}
                    label={t('Sort by')}
                    id="sort"
                    data={{ testid: 'sort-button' }}
                  />
                </Box>
              )}
              align="right"
              onOpen={onSortMenuOpen}
            >
              <MenuItem
                onClick={() => {
                  handleSortChange(APPLIED_JOB_SORT.applicationDate);
                }}
                icon={renderSortIcon(APPLIED_JOB_SORT.applicationDate)}
                data={{ testid: `application-date-sort` }}
              >
                {t('Application date')}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleSortChange(APPLIED_JOB_SORT.companyName);
                }}
                icon={renderSortIcon(APPLIED_JOB_SORT.companyName)}
                data={{ testid: `company-name-sort` }}
              >
                {t('Company name (A-Z)')}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleSortChange(APPLIED_JOB_SORT.jobTitle);
                }}
                icon={renderSortIcon(APPLIED_JOB_SORT.jobTitle)}
                data={{ testid: `job-title-sort` }}
              >
                {t('Job title (A-Z)')}
              </MenuItem>
            </MenuRenderer>
          </Inline>
        </Column>
      </Columns>
    </Box>
  );
};

export default JobsContainerSortView;
